import styled from "styled-components/macro";
import BackgroundGradientImg from "../../assets/images/padme_new_bg.png";

const styles = {
  PageContainer: styled.div`
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 105px);
    // background-image: url(${BackgroundGradientImg});
    background-color: ${({ theme }) => theme.colors.primary.blue800};
    background-size: 100% 100%;
    /* background: radial-gradient(
      circle at 36% 0%,
      rgba(0, 188, 212, 0.05) 0%,
      rgba(239, 239, 239, 1) 100%
    ); */
    @media screen and (max-width: 480px) {
      align-items: flex-start;
    }
  `,
  AlignmentContainer: styled.div`
    width: 100%;
    max-width: 1440px;
    padding: 0 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      padding: 0 2rem;
    }
    @media screen and (max-width: 480px) {
      padding: 0 1rem;
    }
  `,
  ForgotPasswordWrapper: styled.div`
    margin: 2rem 0;
    border-radius: 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
  `,
};

export default styles;
